module.exports = __webpack_public_path__ + "media/que_deviennent_mes_vetements/00-schema-b5793da3.png";